import React from 'react';
import { useTranslation } from '~/shared/utils/translation';
import ProfileHeader from '../ProfileHeader/ProfileHeader';
import SettingsPanel from '../../components/SettingsPanel/SettingsPanel';
import styles from './ProfileTabs.module.scss';

const ProfileSettings: React.FC = () => {
    const { translate } = useTranslation();
    return (
        <div className={styles.tabContent}>
            <div className={styles.inner}>
                <ProfileHeader
                    title={translate('loyalty.settings.title')}
                    subtitle={translate('loyalty.settings.subtitle')}
                />
                <section className={styles.settingsSection}>
                    <SettingsPanel />
                </section>
            </div>
        </div>
    );
};

export default ProfileSettings;
